import { action } from 'typesafe-actions';
import { GiroWebappError } from 'model/error';
import { ShareholderInviteConfirmation } from 'model/shareholder-invite';
import { FundResourcesSourceActionTypes } from './types';

export const fundResourcesSourceRequest = (fundId: string) => action(FundResourcesSourceActionTypes.FUND_RESOURCES_SOURCE_REQUEST, fundId);
export const fundResourcesSourceSuccess = (response: ShareholderInviteConfirmation) => action(FundResourcesSourceActionTypes.FUND_RESOURCES_SOURCE_SUCCESS, response);
export const fundResourcesSourceError = (error: GiroWebappError) => action(FundResourcesSourceActionTypes.FUND_RESOURCES_SOURCE_ERROR, error);
export const fundResourcesSourceResetState = () => action(FundResourcesSourceActionTypes.FUND_RESOURCES_SOURCE_RESET_STATE);
